require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./sheshines-17-feb-2026.json") })
        }
      }, "path---sheshines-17-feb-2026");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---sheshines-17-feb-2026!./.cache/json/sheshines-17-feb-2026.json
// module id = 1225
// module chunks = 231608221292675